<template>
  <div>
    <div
      class="campaign-notification">
      <div v-if="surveyIsAvailable">
        <div>
          <router-link
            :to="{name:'survey',params:{keyword:20250303} }"
            class="c-text-link">
            <img
              class="campaign-notification__banner-pc"
              src="/img/narasu/survey.jpg"
              alt="narasuユーザーアンケート">
            <img
              class="campaign-notification__banner-sp"
              src="/img/narasu/survey_sp.jpg"
              alt="narasuユーザーアンケート">
          </router-link>
        </div>
      </div>
      <div v-if="false">
        <div
          style="background:#DDDDDD">
          <a
            href="/service/broadcast/"
            target="_blank">
            <img
              class="campaign-notification__banner-pc"
              src="/img/narasu/narasu_secondary_banner_pc.jpg"
              alt="narasuの放送二次使用料分配サービス">
            <img
              class="campaign-notification__banner-sp"
              src="/img/narasu/narasu_secondary_banner_sp.jpg"
              alt="narasuの放送二次使用料分配サービス">
          </a>
        </div>
      </div>
      <div v-if="isBtoC">
        <div style="background:#DDDDDD">
          <a
            href="/service/license/"
            target="_blank">
            <img
              class="campaign-notification__banner-pc"
              src="/img/narasu/copyright-banner-pc-20240416.png"
              alt="narasuの著作権管理サービス">
            <img
              class="campaign-notification__banner-sp"
              src="/img/narasu/copyright-banner-sp-20240416.png"
              alt="narasuの著作権管理サービス">
          </a>
        </div>
      </div>
      <div v-if="isBtoC && false">
        <div>
          <a
            href="/client/static/artists"
            target="_blank">
            <img
              class="campaign-notification__banner-pc"
              src="/img/narasu/mypage-artists_pc.jpg"
              alt="アーティストページを活用しよう！">
            <img
              class="campaign-notification__banner-sp"
              src="/img/narasu/mypage-artists_sp.jpg"
              alt="アーティストページを活用しよう！">
          </a>
        </div>
      </div>
      <div v-if="isBtoC && false">
        <div>
          <a
            href="/service/submit"
            target="_blank">
            <img
              class="campaign-notification__banner-pc"
              src="/img/narasu/submit-banner-pc-20240724.png"
              alt="submit">
            <img
              class="campaign-notification__banner-sp"
              src="/img/narasu/submit-banner-sp-20240724.png"
              alt="submit">
          </a>
        </div>
      </div>
    </div>
    <div
      v-if="campaignIsAvailable"
      class="campaign-notification">
      <div>
        <a
          href="/client/static/cam202210-01"
          target="_blank">
          <img
            class="campaign-notification__banner-pc"
            src="/img/narasu/vocacolle_narasu_2209_banner_640x100_fix2.jpg"
            alt="2022 Autumn campaign">
          <img
            class="campaign-notification__banner-sp"
            src="/img/narasu/vocacolle_narasu_2209_banner_854x220_DBSP.jpg"
            alt="2022 Autumn campaign">
        </a>
      </div>
    </div>
    <div
      v-if="campaignIsAvailable"
      class="campaign-notification"
      style="background-color:#dddddd;box-shadow: 0 0 0px 0;">
      <div class="vocaloid-notice">
        VOCALOID、その他音声合成ソフトを使った配信については、以下ページをご確認ください。
        <div>
          <a
            href="https://narasu.jp/lp/vocalo/"
            class="c-text-link"
            target="_blank">
            &gt;&gt;VOCALOID、その他音声合成ソフトの利用について
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CampaignNotification',
  props: {
    createdAt: {
      type: String,
      default: '',
    },
    registeredAt: {
      type: String,
      default: '',
    },
    campaignDeadline: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      surveyIsAvailable: false,
      campaignIsAvailable: false,
    }
  },
  async mounted() {
    const { data } = await window.axios.get('/api/client/campaigns', {
      params: {
        keys: ['vocaloid_contest202210'], // ボーカロイドコンテストのキャンペーンを取り出す
      },
    })
    const contest = data.find((campaign) => campaign.key === 'vocaloid_contest202210') ?? false
    this.campaignIsAvailable = !!contest
    await this.fetchSurvey()
  },
  methods: {
    async fetchSurvey() {
      const { data } = await window.axios.get('/api/client/survey/20250303/status')
      this.surveyIsAvailable = data.status
    },
  },
}
</script>
<style scoped>
.vocaloid-notice {
  margin: 8px auto 25px 0;
  display: block;
  font-size: 1.4rem;
}
.campaign-notification{
  margin-bottom:0;
}
.c-text-link{
  font-weight:bold;
}
</style>
